module.exports = __webpack_public_path__ + "static/media/01A.f0bb3652.png";